import React from 'react';

const SvgEyeHide = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M4.207 2.793L2.793 4.207 5.076 6.49C2.2 8.838 1 12 1 12s3 8 11 8c2.076 0 3.806-.545 5.242-1.344l2.551 2.551 1.414-1.414-17-17zM12 4c-1.212 0-2.294.2-3.283.512l2.56 2.56C11.514 7.037 11.753 7 12 7a5 5 0 015 5c0 .247-.037.486-.072.723l3.43 3.43C22.203 14.102 23 12 23 12s-3-8-11-8zM7.834 9.248l1.463 1.463C9.108 11.1 9 11.537 9 12a3 3 0 003 3c.463 0 .9-.108 1.29-.297l1.462 1.463A4.96 4.96 0 0112 17a5 5 0 01-5-5c0-1.02.31-1.962.834-2.752z" />
  </svg>
);

export default SvgEyeHide;
